import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Sofía M.',
  location: 'Buenos Aires',
  role: 'Profe de Ritmos Latinos en Gimnasio',
  quote: 'Organicé toda mi planificación anual en un fin de semana. Ahora tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico antes de la semana.'
}, {
  name: 'Carolina R.',
  location: 'Rosario',
  role: 'Profe de Ritmos Latinos en Academia de Baile',
  quote: 'Las progresiones técnicas por nivel cambiaron todo. Mis alumnos mejoraron más en 2 meses que en todo el año anterior. Y dejaron de irse.'
}, {
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Profe de Ritmos Latinos Grupal e Individual',
  quote: 'Adapto la misma coreografía a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo.'
}];
export function TestimonialsSection() {
  return <section className="py-10 md:py-20 bg-neutral-950 relative overflow-hidden" data-id="element-317">
      <div className="container mx-auto px-4" data-id="element-318">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6 max-w-4xl md:max-w-none mx-auto" data-id="element-319">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-neutral-900 border border-neutral-800 rounded-xl p-3 md:p-8 relative" data-id="element-320">
              <Quote className="absolute top-4 right-4 w-6 h-6 text-neutral-800" data-id="element-321" />
              <div className="flex gap-0.5 mb-3" data-id="element-322">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 md:w-5 md:h-5 text-amber-500 fill-amber-500" data-id="element-323" />)}
              </div>
              <p className="text-neutral-300 text-sm md:text-lg mb-4 md:mb-8 italic leading-snug md:leading-relaxed" data-id="element-324">
                "{testimonial.quote}"
              </p>
              <div data-id="element-325">
                <div className="font-bold text-white text-sm md:text-lg" data-id="element-326">
                  {testimonial.name}
                </div>
                <div className="text-amber-500 text-xs font-medium" data-id="element-327">
                  {testimonial.location} —{' '}
                  <span className="text-neutral-500" data-id="element-328">{testimonial.role}</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}